<template>
    <section class="student-exam-mode" @contextmenu.prevent>
        <!-- Indikator Loading saat Data API sedang disiapkan -->
        <div v-if="!isDataLoaded" class="text-center my-5 py-5">
            <template v-if="!modal.passcode">
                <b-spinner variant="danger" label="Loading..."></b-spinner>
                <h5 class="mt-3 text-muted font-weight-bold">Memuat soal dan waktu ujian...</h5>
            </template>
        </div>

        <!-- Kontainer Utama -->
        <div v-else class="row">
            <div class="col-10 offset-1">
                <div class="row align-items-end mt-5">
                    <div class="col-md col-12">
                        <nav aria-label="breadcrumb">
                            <ul class="breadcrumb">
                                <li class="breadcrumb-item h3 font-weight-bold mb-0">
                                    <router-link v-bind:to="{ name: 'tryout/index' }">
                                        Tryout
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item font-weight-medium">
                                    <router-link v-bind:to="{ name: 'tryout/view', params: {id: tryout.id} }">
                                        {{ tryout.name }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                                    <template v-if="tryout.tryoutGroups && tryout.tryoutGroups.length && tryoutGroup.groupSubject">
                                        {{ tryoutGroup.groupSubject.name }} {{ tryoutGroup.code }}
                                    </template>
                                    <template v-else-if="tryoutSubject.subject">
                                        {{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}
                                    </template>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="col-auto ml-auto">
                        <label class="badge badge-danger p-2">
                            <h4 class="mb-0 font-weight-bold">
                                Waktu Tersisa
                                <span class="font-weight-light ml-1" v-if="time.displayString">
                                    {{ time.displayString }}
                                </span>
                                <span class="font-weight-light ml-1" v-else-if="time.remaining && time.remaining.isMoment && time.remaining.isMoment()">
                                    {{ time.remaining.format('HH:mm:ss') }}
                                </span>
                                <span class="font-weight-light ml-1" v-else>
                                    --:--:--
                                </span>
                            </h4>
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col">
                                        <span class="font-weight-medium text-white" v-if="tryoutSubject.subject">
                                            {{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row align-items-center mb-3">
                                    <div :class="questionType === 'mc' ? 'col-md-7 col font-weight-bold' : 'col-12 font-weight-bold'">
                                        Deskripsi Soal
                                    </div>
                                    <div class="col-md font-weight-bold d-none d-md-block" v-if="questionType === 'mc'">
                                        Opsi Jawaban
                                    </div>
                                    <div class="col-auto pl-0" v-if="questionType === 'mc' && form.answer.value">
                                        <button class="btn btn-danger btn-sm py-0" type="button" v-on:click="form.answer.value = ''">
                                            Hapus Jawaban
                                        </button>
                                    </div>
                                </div>
                                 <div class="row justify-content-end mb-3">
                                     <div class="col-12 mb-3 question-content-wrap" :class="questionType === 'table' || questionType === 'list' ? 'col-md-12' : 'col-md-7'" v-html="question.content || ''"></div>
                                     <!-- Pilihan Ganda Biasa -->
                                     <div class="col-12 col-md-5" v-if="questionType === 'mc'">
                                         <div class="row" v-for="choice in question.choices" v-bind:key="choice.id">
                                             <div class="col-auto pr-1">
                                                <div class="form-check form-check-inline mr-0">
                                                    <div class="custom-control custom-radio">
                                                        <input v-model="form.answer.value" type="radio" v-bind:value="choice.order" class="custom-control-input" v-bind:id="'input-choice-' + choice.id" />
                                                        <label class="custom-control-label" v-bind:for="'input-choice-' + choice.id">
                                                            {{ choice.order }}.
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col pl-1">
                                                <span v-html="choice.content"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Tabel Pernyataan (isEssay=2) -->
                                    <div class="col-12 mt-2" v-else-if="questionType === 'table'">
                                        <div class="font-weight-bold mb-2">Jawaban</div>
                                        <div class="alert alert-light border small py-2 mb-3">
                                            <i class="fa fa-info-circle mr-1 text-primary"></i>
                                            Pilih jawaban untuk setiap pernyataan dengan mengklik salah satu pilihan.
                                        </div>
                                        <div class="table-container-wrap" style="width: 100%; overflow: visible;">
                                            <table class="table table-bordered table-hover bg-white" style="table-layout: fixed !important; width: 100% !important; margin-bottom: 0;">
                                                <thead class="thead-light">
                                                    <tr>
                                                        <th style="width:50px;min-width:50px;max-width:50px;" class="text-center">No</th>
                                                        <th class="text-center">{{ question.tableData && question.tableData.colStatement || 'Pernyataan' }}</th>
                                                        <th style="width:90px;min-width:90px;max-width:90px;" class="text-center">{{ question.tableData && question.tableData.col1 || 'Benar' }}</th>
                                                        <th style="width:90px;min-width:90px;max-width:90px;" class="text-center">{{ question.tableData && question.tableData.col2 || 'Salah' }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(row, rIdx) in tableAnswer" :key="rIdx">
                                                        <td class="text-center font-weight-bold align-middle">{{ rIdx + 1 }}</td>
                                                        <td class="align-middle text-justify table-statement-cell" style="text-align: justify; vertical-align: middle !important; cursor: default;" ondragstart="return false;">
                                                            <div class="statement-scroll-wrap" v-html="row.statement"></div>
                                                        </td>
                                                        <td class="text-center align-middle" style="cursor: pointer; vertical-align: middle !important;" @click="row.selected = 'col1'">
                                                            <div class="custom-control custom-radio">
                                                                <input type="radio" :id="'bta-tbl-' + rIdx + '-c1'" :name="'bta-tbl-radio-' + rIdx" value="col1" v-model="row.selected" class="custom-control-input" />
                                                                <label class="custom-control-label" :for="'bta-tbl-' + rIdx + '-c1'"></label>
                                                            </div>
                                                        </td>
                                                        <td class="text-center align-middle" style="cursor: pointer; vertical-align: middle !important;" @click="row.selected = 'col2'">
                                                            <div class="custom-control custom-radio">
                                                                <input type="radio" :id="'bta-tbl-' + rIdx + '-c2'" :name="'bta-tbl-radio-' + rIdx" value="col2" v-model="row.selected" class="custom-control-input" />
                                                                <label class="custom-control-label" :for="'bta-tbl-' + rIdx + '-c2'"></label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <!-- List Checkbox (isEssay=3) -->
                                    <div class="col-12 mt-2" v-else-if="questionType === 'list'">
                                        <div class="font-weight-bold mb-2">Jawaban</div>
                                        <div class="alert alert-light border small py-2 mb-3">
                                            <i class="fa fa-info-circle mr-1 text-primary"></i>
                                            Centang satu atau lebih pilihan yang menurut Anda benar.
                                        </div>
                                        <div class="list-group">
                                            <div v-for="(item, iIdx) in listAnswer" :key="iIdx" class="list-group-item list-group-item-action d-flex align-items-center mb-2 rounded border py-2 px-3 list-option-item" :class="{'list-group-item-light font-weight-bold text-primary': item.checked}" style="cursor: pointer;" @click="item.checked = !item.checked">
                                                <div class="mr-3 d-flex align-items-center justify-content-center" style="flex-shrink: 0;">
                                                    <input type="checkbox" :id="'bta-lst-' + iIdx" v-model="item.checked" @click.stop style="width: 20px; height: 20px; cursor: pointer; margin: 0; vertical-align: middle; accent-color: #007bff;" />
                                                </div>
                                                <div v-html="item.content" class="flex-grow-1 mb-0 align-self-center list-content-wrap"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Essay biasa & Numerik -->
                                    <div class="col-12 col-md-5" v-else>
                                        <div class="font-weight-bold mb-2 d-flex justify-content-between align-items-center">
                                            <span>Jawaban</span>
                                            <span v-if="isNumericEssay" class="badge badge-info font-weight-normal py-1 px-2" style="font-size: 0.8rem;">
                                                <i class="fa fa-calculator mr-1"></i> Hanya Input Angka (Numerik)
                                            </span>
                                        </div>
                                        <div class="alert alert-light border small py-2 mb-2" v-if="isNumericEssay">
                                            <i class="fa fa-info-circle mr-1 text-primary"></i>
                                            Kotak jawaban ini dibatasi hanya bisa menerima input angka (0-9).
                                        </div>
                                        <tinymce :key="question.id" id="text-editor" v-on:editorInit="initTinyMce" v-model="form.answer.value" v-bind:other_options="tinyMCEOptions"></tinymce>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col">
                                        <h4 class="font-weight-medium text-white mb-0">
                                            Nomor Soal
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <template v-if="!tryout.isLocked && tryout.tryoutGroups && tryout.tryoutGroups.length">
                                    <template v-for="tryoutSubjectPagination in paginations">
                                        <h4 class="font-weight-bold text-uppercase mx-3" :key="'subject-head-' + tryoutSubjectPagination.id">
                                            {{ tryoutSubjectPagination.subject ? tryoutSubjectPagination.subject.name : '' }}
                                        </h4>
                                        <ul class="pagination pagination-sm justify-content-start flex-wrap mb-4" :key="'subject-list-' + tryoutSubjectPagination.id">
                                            <li class="page-item m-2" v-bind:class="{active: isActive(index + 1) && question.tryoutSubjectID === tryoutSubjectPagination.id, empty: !pagination.studentAnswer}" v-for="(pagination, index) in tryoutSubjectPagination.questions" :key="'q-' + pagination.id">
                                                <a href="#" class="page-link shadow-sm" tabindex="0" v-on:click.prevent="tryoutSubject = tryoutSubjectPagination; answer(index + 1)">
                                                    {{ index + 1 }}
                                                </a>
                                            </li>
                                        </ul>
                                    </template>
                                </template>
                                <template v-else>
                                    <ul class="pagination pagination-sm justify-content-start flex-wrap">
                                        <li class="page-item m-2" v-bind:class="{active: isActive(index + 1), empty: !pagination.studentAnswer}" v-for="(pagination, index) in paginations" :key="'q-single-' + pagination.id">
                                            <a href="#" class="page-link shadow-sm" tabindex="0" v-on:click.prevent="answer(index + 1)">
                                                {{ index + 1 }}
                                            </a>
                                        </li>
                                    </ul>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="tryout.hasSubmit">
                    <div class="col-auto ml-auto">
                        <button type="button" v-on:click="modal.submit = true" class="btn btn-danger btn-sm px-5">
                            Saya telah mengerjakan semua soal, dan Selesaikan TO
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Submit Manual -->
        <b-modal v-model="modal.submit" modal-class="border-0" header-class="background-primary" footer-class="justify-content-center" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menyelesaikan Tryout <span class="font-weight-bold" v-if="tryoutSubject.subject">{{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}</span>? Jika belum yakin silahkan cek kembali jawaban, karena jika sudah diselesaikan jawaban tidak dapat diubah.</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="submit(true)">
                            Selesai
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.submit = false">
                            Batal
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- Modal Passcode Attempt Ujian -->
        <b-modal v-model="modal.passcode" modal-class="border-0" header-class="background-primary" footer-class="justify-content-center" v-bind:centered="true" v-bind:hide-footer="true" v-bind:no-close-on-backdrop="true" v-bind:no-close-on-esc="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Masukkan Password Ujian
                </h4>
            </template>
            <div class="container text-center py-2">
                <form @submit.prevent="attempt">
                    <div class="form-group mb-3 px-4">
                        <input type="text" v-model="form.attempt.passcode" class="form-control text-center" placeholder="Password Soal" required />
                    </div>
                    <div class="col-12 text-center">
                        <button type="submit" class="btn btn-danger btn-sm px-4">Masuk Soal</button>
                        <button type="button" v-on:click="cancelPasscode" class="btn btn-outline-danger btn-sm px-4 ml-2">
                            Batal
                        </button>
                    </div>
                </form>
            </div>
        </b-modal>

        <!-- Modal Peringatan Berpindah Layar -->
        <b-modal v-model="modal.attempt" modal-class="border-0" header-class="background-primary" footer-class="justify-content-center" v-bind:centered="true" v-bind:hide-footer="true" v-bind:no-close-on-backdrop="true" v-bind:no-close-on-esc="true" v-bind:hide-header-close="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    PERINGATAN UJIAN!
                </h4>
            </template>
            <div class="container text-center py-2">
                <div class="row">
                    <div class="col-12 mb-3">
                        <h5 class="font-weight-bold text-danger mb-2">Terdeteksi Berpindah Halaman / Layar!</h5>
                        <p class="text-muted small mb-1">
                            Anda terdeteksi meninggalkan halaman pengerjaan ujian.
                        </p>
                        <p class="font-weight-bold text-dark small mb-3">
                            Harap hubungi pengawas ujian.
                        </p>
                    </div>
                    <div class="col-12 mb-2 px-4">
                        <form @submit.prevent="closeWarningModal">
                            <div class="form-group mb-2">
                                <label class="small font-weight-bold text-muted">Kata Sandi Pengawas Ujian:</label>
                                <input 
                                    type="password" 
                                    v-model="supervisorPasscode" 
                                    class="form-control form-control-sm text-center" 
                                    placeholder="Masukkan password pengawas"
                                    required 
                                />
                            </div>
                            <button 
                                type="submit" 
                                class="btn btn-danger px-5 btn-sm mt-2"
                                :disabled="!supervisorPasscode"
                            >
                                Lanjutkan Ujian
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- Modal Konfirmasi Lanjutkan Mata Pelajaran -->
        <b-modal v-model="modal.confirm" modal-class="border-0" header-class="background-primary" footer-class="justify-content-center" v-bind:centered="true" v-bind:hide-footer="true" v-bind:no-close-on-backdrop="true" v-bind:no-close-on-esc="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Konfirmasi
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">TO telah diselesaikan, melanjutkan ke mata pelajaran berikutnya?</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="fetchData()">
                            Lanjutkan <span v-if="remainingConfirm" class="font-weight-bold">({{ $moment.duration(remainingConfirm).asSeconds() }})</span>
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- Modal Peringatan Sisa Waktu 3 Menit -->
        <b-modal 
            v-model="modal.timeWarning" 
            modal-class="border-0" 
            header-class="background-primary" 
            footer-class="justify-content-center" 
            v-bind:centered="true" 
            v-bind:hide-footer="true"
            v-bind:no-close-on-backdrop="true"
            v-bind:no-close-on-esc="true"
        >
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Peringatan Waktu!
                </h4>
            </template>
            <div class="container text-center py-2">
                <div class="row">
                    <div class="col-12 mb-3">
                        <h5 class="font-weight-bold text-danger mb-2">Waktu Pengerjaan Hampir Habis</h5>
                        <p class="text-muted small mb-1">
                            Sisa waktu pengerjaan Anda kurang dari <strong>{{ time.remainingString }}</strong>.
                        </p>
                        <p class="text-muted small mb-0">
                            Harap periksa kembali jawaban Anda sebelum waktu habis secara otomatis.
                        </p>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-danger btn-sm px-5" v-on:click="modal.timeWarning = false">
                            Lanjutkan Pengerjaan
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>

        <div class="row">
            <div class="col text-center mt-5">
                <Adsense v-bind:data-ad-client="googleAdsClientKey" data-ad-slot="6426122373"></Adsense>
            </div>
        </div>
    </section>
</template>

<script>
    import tinymce from 'vue-tinymce-editor';
    import { tinyMCEOptions } from '@/params.js';

    export default {
        name: "TryoutQuestionView",
        components: {
            tinymce
        },
        data() {
            return {
                form: {
                    answer: {value: ''},
                    attempt: {passcode: localStorage.getItem('passcodeAttempt')}
                },
                supervisorPasscode: '',
                tryout: {tryoutGroups: []},
                tryoutGroup: {groupSubject: {}, groupAttempts: []},
                tryoutSubject: {subject: {}, subjectAttempts: []},
                question: {choices: []},
                page: 1,
                googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
                time: {
                    remaining: null,
                    duration: null,
                    displayString: '',
                    remainingString: ''
                },
                paginations: [],
                modal: {
                    submit: false,
                    attempt: false,
                    passcode: false,
                    confirm: false,
                    timeWarning: false
                },
                remainingConfirm: 0,
                startTime: 0,
                intervals: {
                    cron: null,
                    confirm: null
                },
                inactiveTime: 0,
                trigger: false,
                isTimerReady: false,
                isDataLoaded: false,
                submitAttemptCount: 0,
                isCursorInside: true,
                isWindowFocused: true,
                isNotifyingServerLock: false,
                isCancellingPasscode: false,
                tableAnswer: [],
                listAnswer: [],
                tinyMCEOptions: {
                    ...tinyMCEOptions,
                    toolbar: false,
                    menubar: false,
                    table_toolbar: false,
                    object_resizing: false,
                    height: '400',
                    valid_elements: '*[*]',
                    extended_valid_elements: 'input[type|name|value|checked|disabled]',
                    contextmenu: false,
                }
            };
        },
        computed: {
            // PERBAIKAN: Membaca field `hasSessionChecking` dari API response management secara presisi
            isSessionCheckEnabled() {
                if (this.tryout) {
                    if (typeof this.tryout.hasSessionChecking !== 'undefined') {
                        return !!this.tryout.hasSessionChecking;
                    }
                    if (typeof this.tryout.hasSessionCheck !== 'undefined') {
                        return !!this.tryout.hasSessionCheck;
                    }
                    if (typeof this.tryout.isSessionCheck !== 'undefined') {
                        return !!this.tryout.isSessionCheck;
                    }
                }
                return false; // Fallback false agar tidak memblokir siswa jika opsi dinonaktifkan
            },
            questionType() {
                if (!this.question) return 'mc';
                if (!this.question.isEssay) return 'mc';
                if (this.question.isEssay === 2 || this.question.isEssay === '2') return 'table';
                if (this.question.isEssay === 3 || this.question.isEssay === '3') return 'list';
                if (this.tableAnswer && this.tableAnswer.length > 0) return 'table';
                if (this.listAnswer && this.listAnswer.length > 0) return 'list';
                if (this.question.tableData && this.question.tableData.rows && this.question.tableData.rows.length) return 'table';
                if (this.question.listData && this.question.listData.items && this.question.listData.items.length) return 'list';
                const answerHTML = this.question.answer || '';
                const defaultHTML = this.question.defaultAnswer || '';
                const contentHTML = this.question.content || '';
                if ((answerHTML.includes('<table') || defaultHTML.includes('<table') || contentHTML.includes('<table')) && 
                    (answerHTML.includes('type="radio"') || defaultHTML.includes('type="radio"') || contentHTML.includes('type="radio"'))) return 'table';
                if ((answerHTML.includes('<ul') || defaultHTML.includes('<ul') || contentHTML.includes('<ul')) && 
                    (answerHTML.includes('type="checkbox"') || defaultHTML.includes('type="checkbox"') || contentHTML.includes('type="checkbox"'))) return 'list';
                return 'essay';
            },
            isNumericEssay() {
                return this.questionType === 'essay' && 
                       !!(this.question && this.question.defaultAnswer && this.question.defaultAnswer.includes('data-numeric="true"'));
            }
        },
        // Proteksi 1: Tolak navigasi Vue Router jika status pengawas terkunci atau modal terbuka
        beforeRouteLeave(to, from, next) {
            // Siswa belum mulai mengerjakan (masih di modal password soal) -> izinkan keluar
            if (this.isCancellingPasscode || (this.modal.passcode && !this.modal.attempt)) {
                next();
                return;
            }
            if (this.isSessionCheckEnabled && (this.modal.attempt || localStorage.getItem('supervisorLocked') === 'true')) {
                this.$toastr('warning', 'Harap masukkan kata sandi pengawas terlebih dahulu!', 'Akses Ditolak');
                next(false);
            } else {
                next();
            }
        },
        watch: {
            '$route.params': {
                handler() {
                    this.fetchData();
                },
                deep: true
            },
            // Proteksi 2: Simpan flag 'supervisorLocked' ke localStorage dan catat peringatan keluar ke server saat modal muncul
            'modal.attempt'(isWarningActive) {
                if (isWarningActive) {
                    localStorage.setItem('supervisorLocked', 'true');
                    window.history.pushState(null, null, window.location.href);
                    this.lockSessionOnServer();
                }
            },
            'time.remaining'(val) {
                if (!val) return;

                let delay = 1000;
                setTimeout(() => {
                    requestAnimationFrame(activeTime => {
                        if (!this.isTimerReady || !this.time.remaining || !this.time.duration || !this.startTime) {
                            return;
                        }
                        
                        let elapsedTime = activeTime - this.startTime;
                        let durationMs = typeof this.time.duration === 'number' 
                            ? this.time.duration 
                            : (this.time.duration.asMilliseconds ? this.time.duration.asMilliseconds() : Number(this.time.duration));

                        let remainingMs = durationMs - elapsedTime;
                        
                        if (remainingMs > 0) {
                            let nextMoment = this.$moment(remainingMs).utcOffset(0);
                            this.time.displayString = nextMoment.format('HH:mm:ss');
                            this.time.remaining = nextMoment;
                        } else {
                            this.time.displayString = '00:00:00';
                            
                            // Submit otomatis saat waktu pengerjaan resmi habis:
                            // Wajib submit meskipun siswa sedang membuka layar/tab lain atau popup pengawas sedang muncul
                            if (
                                this.isDataLoaded && 
                                this.paginations.length > 0 && 
                                elapsedTime >= 2000
                            ) {
                                console.log('[SUBMIT] Waktu pengerjaan resmi habis, otomatis submit!');
                                this.modal.attempt = false;
                                this.modal.timeWarning = false;
                                localStorage.removeItem('supervisorLocked');
                                this.submit(true);
                            }
                        }
                    });
                }, delay);
            },
            'modal.confirm'(modal) {
                clearInterval(this.intervals.confirm);

                if (modal) {
                    this.remainingConfirm = 30 * 1000;
                    let delay = 1000;
                    this.intervals.confirm = setInterval(() => {
                        this.remainingConfirm -= delay;
                        if (this.remainingConfirm < delay) {
                            clearInterval(this.intervals.confirm);
                            this.modal.confirm = false;
                            this.remainingConfirm = 0;
                            this.fetchData();
                        }
                    }, delay);
                }
            }
        },
        methods: {
            // Batal memasukkan password soal: kembali ke halaman pilihan TO
            cancelPasscode() {
                this.isCancellingPasscode = true;
                localStorage.removeItem('supervisorLocked');
                this.modal.passcode = false;
                let tryoutID = (this.tryout && this.tryout.id) ? this.tryout.id : this.$route.params.id;
                this.$router.replace({ name: 'tryout/view', params: { id: tryoutID } });
            },
            // Proteksi 3: Tangkap tombol Back bawaan browser saat terkunci
            handlePopState() {
                if (this.isSessionCheckEnabled && (this.modal.attempt || localStorage.getItem('supervisorLocked') === 'true')) {
                    window.history.pushState(null, null, window.location.href);
                    this.$toastr('warning', 'Harap masukkan kata sandi pengawas terlebih dahulu!', 'Akses Ditolak');
                }
            },
            getCurrentTryoutSubjectID() {
                if (this.question && this.question.tryoutSubjectID) {
                    return parseInt(this.question.tryoutSubjectID);
                }
                if (this.tryoutSubject && this.tryoutSubject.id) {
                    return parseInt(this.tryoutSubject.id);
                }
                if (this.$route.params.tryoutSubjectID) {
                    return parseInt(this.$route.params.tryoutSubjectID);
                }
                if (this.paginations && this.paginations.length) {
                    if (this.paginations[0].questions && this.paginations[0].questions.length) {
                        return parseInt(this.paginations[0].id);
                    }
                }
                if (this.tryoutGroup && this.tryoutGroup.tryoutSubjects && this.tryoutGroup.tryoutSubjects.length) {
                    return parseInt(this.tryoutGroup.tryoutSubjects[0].id);
                }
                return null;
            },
            getCurrentTryoutGroupID() {
                if (this.tryoutGroup && this.tryoutGroup.id) {
                    return parseInt(this.tryoutGroup.id);
                }
                if (this.$route.params.tryoutGroupID) {
                    return parseInt(this.$route.params.tryoutGroupID);
                }
                return null;
            },
            async closeWarningModal() {
                let inputPasscode = (this.supervisorPasscode || '').trim();
                if (!inputPasscode) {
                    this.$toastr('error', 'Harap masukkan kata sandi pengawas!', 'Akses Ditolak');
                    return;
                }

                // Verifikasi sandi pengawas & sinkronisasi pembukaan kunci ke server
                try {
                    let subjectID = this.getCurrentTryoutSubjectID();
                    let groupID = this.getCurrentTryoutGroupID();
                    let tryoutID = (this.tryout && this.tryout.id) ? parseInt(this.tryout.id) : parseInt(this.$route.params.id);
                    let isGroup = !!groupID;
                    let url = isGroup ? '/group-attempt' : '/subject-attempt';
                    let params = {
                        sessionLock: 'unlock',
                        supervisorPasscode: inputPasscode,
                        tryoutID: tryoutID
                    };
                    if (isGroup) {
                        params.tryoutGroupID = groupID;
                    }
                    if (subjectID) {
                        params.tryoutSubjectID = subjectID;
                    }
                    const response = await this.axios.post(process.env.API_URL + url, params);
                    if (!response.data || !response.data.status) {
                        this.$toastr('error', (response.data && response.data.message) ? response.data.message : 'Kata sandi pengawas salah!', 'Akses Ditolak');
                        this.supervisorPasscode = '';
                        return;
                    }
                } catch (e) {
                    console.error('[SESSION UNLOCK] Gagal sinkronisasi buka kunci ke server:', e);
                    let errMsg = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Kata sandi pengawas salah!';
                    this.$toastr('error', errMsg, 'Akses Ditolak');
                    this.supervisorPasscode = '';
                    return;
                }

                this.$toastr('success', 'Akses pengerjaan dilanjutkan', 'Berhasil');
                
                localStorage.removeItem('supervisorLocked');
                this.modal.attempt = false;
                this.inactiveTime = 0;
                this.supervisorPasscode = '';
                this.isCursorInside = true;
                this.isWindowFocused = true;

                requestAnimationFrame(activeTime => {
                    if (this.time.remaining && this.$moment.isMoment(this.time.remaining)) {
                        let currentRemainingMs = this.time.remaining.valueOf();
                        
                        this.time.duration = currentRemainingMs;
                        this.startTime = activeTime;
                        
                        let nextMoment = this.$moment(currentRemainingMs).utcOffset(0);
                        this.time.displayString = nextMoment.format('HH:mm:ss');
                        this.$set(this.time, 'remaining', nextMoment);
                    } else {
                        this.startTime = activeTime;
                    }

                    this.cron();
                });
            },
            async lockSessionOnServer() {
                if (this.isNotifyingServerLock) return;
                this.isNotifyingServerLock = true;
                try {
                    let subjectID = this.getCurrentTryoutSubjectID();
                    let groupID = this.getCurrentTryoutGroupID();
                    let isGroup = !!groupID;
                    let url = isGroup ? '/group-attempt' : '/subject-attempt';
                    let params = { sessionLock: 'lock' };

                    if (isGroup) {
                        params.tryoutGroupID = groupID;
                    }
                    if (subjectID) {
                        params.tryoutSubjectID = subjectID;
                    }

                    await this.axios.post(process.env.API_URL + url, params);
                } catch (e) {
                    console.error('[SESSION LOCK] Gagal mengunci sesi di server:', e);
                } finally {
                    this.isNotifyingServerLock = false;
                }
            },
            handleWindowBlur() {
                if (this.isEditorActive()) {
                    return;
                }
                this.isWindowFocused = false;
            },
            handleWindowFocus() {
                this.isWindowFocused = true;
                this.isCursorInside = true;
            },
            handleMouseLeave(e) {
                if (e && e.relatedTarget && (e.relatedTarget.tagName === 'IFRAME' || (e.relatedTarget.closest && e.relatedTarget.closest('.mce-tinymce, iframe')))) {
                    return;
                }
                this.isCursorInside = false;
            },
            handleMouseEnter() {
                this.isCursorInside = true;
                this.isWindowFocused = true;
            },
            handleMouseMove() {
                this.isCursorInside = true;
            },
            handleWindowMouseOut(e) {
                if (!e.relatedTarget && !e.toElement) {
                    this.isCursorInside = false;
                }
            },
            handleVisibilityChange() {
                if (document.hidden) {
                    this.isWindowFocused = false;
                } else {
                    this.isWindowFocused = true;
                }
            },
            isEditorActive() {
                try {
                    if (document.activeElement && (document.activeElement.tagName === 'IFRAME' || document.activeElement.closest('.mce-tinymce'))) {
                        return true;
                    }
                    if (window.tinymce && window.tinymce.activeEditor && window.tinymce.activeEditor.hasFocus && window.tinymce.activeEditor.hasFocus()) {
                        return true;
                    }
                } catch (e) {}
                return false;
            },
            async attempt() {
                let isGroup = !this.tryout.isLocked && this.tryout.tryoutGroups && this.tryout.tryoutGroups.length;
                let url = isGroup ? '/group-attempt' : '/subject-attempt';
                let params = {};
                
                if (isGroup) {
                    let groupID = this.tryoutGroup && this.tryoutGroup.id ? this.tryoutGroup.id : parseInt(this.$route.params.tryoutGroupID);
                    params = { tryoutGroupID: groupID };
                } else {
                    let subjectID = this.tryoutSubject && this.tryoutSubject.id ? this.tryoutSubject.id : parseInt(this.$route.params.tryoutSubjectID);
                    params = { tryoutSubjectID: subjectID };
                }

                let requestParams = Object.assign({}, this.form.attempt, params);

                try {
                    const response = await this.axios.post(process.env.API_URL + url, requestParams);

                    if (response.data && response.data.status) {
                        this.modal.attempt = false;
                        this.modal.passcode = false;

                        let attemptData = response.data.data;
                        
                        if (isGroup && this.tryoutGroup) {
                            this.$set(this.tryoutGroup, 'groupAttempts', [attemptData]);
                        } else if (this.tryoutSubject) {
                            this.$set(this.tryoutSubject, 'subjectAttempts', [attemptData]);
                        }

                        if (this.tryout.isLocked && this.tryout.tryoutGroups && this.tryout.tryoutGroups.length) {
                            if (this.tryoutSubject.subjectAttempts && this.tryoutSubject.subjectAttempts.length && this.tryoutSubject.subjectAttempts[0].tryoutSubject && this.tryoutSubject.subjectAttempts[0].tryoutSubject.tryoutGroup) {
                                localStorage.setItem('passcodeAttempt', this.tryoutSubject.subjectAttempts[0].tryoutSubject.tryoutGroup.passcode);
                            }
                        } else {
                            localStorage.removeItem('passcodeAttempt');
                        }

                        this.inactiveTime = 0;
                        await this.loadQuestionsAndTimer();
                    } else {
                        // Cek apakah response menunjukkan tryout terkunci oleh pengawas:
                        if (response.data && (response.data.isSupervisorLocked || (response.data.errors && response.data.errors.supervisor))) {
                            this.modal.passcode = false;
                            this.modal.attempt = true;
                            localStorage.setItem('supervisorLocked', 'true');
                            this.$toastr('warning', response.data.message || 'Ujian sedang terkunci oleh pengawas. Silakan hubungi pengawas.', 'Peringatan');
                            return;
                        }

                        // Password salah atau verifikasi gagal untuk password ujian/soal
                        this.modal.passcode = true;
                        this.form.attempt.passcode = '';
                        
                        let errorMsg = 'Password yang Anda masukkan salah!';
                        if (response.data && response.data.errors && Object.keys(response.data.errors).length > 0) {
                            let firstKey = Object.keys(response.data.errors)[0];
                            errorMsg = response.data.errors[firstKey][0] || errorMsg;
                        } else if (response.data && response.data.message) {
                            errorMsg = response.data.message;
                        }
                        this.$toastr('warning', errorMsg, 'Peringatan');
                    }
                } catch (error) {
                    console.error('[ATTEMPT] Gagal memverifikasi password:', error);
                    if (error.response && error.response.data && (error.response.data.isSupervisorLocked || (error.response.data.errors && error.response.data.errors.supervisor))) {
                        this.modal.passcode = false;
                        this.modal.attempt = true;
                        localStorage.setItem('supervisorLocked', 'true');
                        this.$toastr('warning', error.response.data.message || 'Ujian sedang terkunci oleh pengawas.', 'Peringatan');
                        return;
                    }

                    this.modal.passcode = true;
                    this.form.attempt.passcode = '';
                    
                    let errorMsg = 'Gagal memverifikasi password, silakan coba lagi';
                    if (error.response && error.response.data && error.response.data.errors && Object.keys(error.response.data.errors).length > 0) {
                        let firstKey = Object.keys(error.response.data.errors)[0];
                        errorMsg = error.response.data.errors[firstKey][0] || errorMsg;
                    }
                    this.$toastr('error', errorMsg, 'Error');
                }
            },
            submit(isUserIntentional = false) {
                if (!isUserIntentional) {
                    console.warn('[GUARD] Submit otomatis dicegah!');
                    return;
                }

                this.submitAttemptCount++;
                if (this.submitAttemptCount > 1) {
                    return;
                }
                
                if (!this.isDataLoaded) {
                    this.submitAttemptCount = 0;
                    return;
                }
                
                this.modal.attempt = false;
                this.modal.timeWarning = false;
                localStorage.removeItem('supervisorLocked');
                
                this.answer();
                this.modal.submit = false;
                if (!this.tryout.isLocked && this.tryout.tryoutGroups && this.tryout.tryoutGroups.length) {
                    this.axios.post(process.env.API_URL + '/group-attempt/submit', {tryoutGroupID: this.tryoutGroup.id})
                        .then(() => {
                            this.$router.replace({name: 'tryout/view', params: {id: this.tryout.id}});
                        })
                        .catch(error => {
                            console.error('[ERROR] Submit group-attempt failed:', error);
                            this.$toastr('error', 'Gagal menyimpan, silakan coba lagi', 'Error');
                            this.submitAttemptCount = 0;
                        });
                } else {
                    this.axios.post(process.env.API_URL + '/subject-attempt/submit', {tryoutSubjectID: this.tryoutSubject.id})
                        .then(() => {
                            if (this.tryout.isLocked && this.tryout.tryoutGroups && this.tryout.tryoutGroups.length) {
                                let lastTryourSubject = this.tryoutGroup.tryoutSubjects[this.tryoutGroup.tryoutSubjects.length - 1];
                                if (lastTryourSubject && lastTryourSubject.id !== this.tryoutSubject.id) {
                                    this.modal.confirm = true;
                                } else {
                                    this.fetchData();
                                }
                            } else {
                                this.$router.replace({name: 'tryout/view', params: {id: this.tryout.id}});
                            }
                        })
                        .catch(error => {
                            console.error('[ERROR] Submit subject-attempt failed:', error);
                            this.$toastr('error', 'Gagal menyimpan, silakan coba lagi', 'Error');
                            this.submitAttemptCount = 0;
                        });
                }
            },
            answer(nextPage) {
                nextPage = nextPage || null;
                // Handle Essay (Biasa & Numerik)
                if (this.questionType === 'essay') {
                    const editor = window.tinymce.get('text-editor');
                    if (editor) {
                        if (this.isNumericEssay) {
                            const rawText = editor.getContent({ format: 'text' }) || '';
                            const cleanDigits = rawText.replace(/[^0-9]/g, '');
                            this.form.answer.value = cleanDigits ? `<p>${cleanDigits}</p>` : '';
                        } else {
                            const editorBody = editor.getBody().cloneNode(true);
                            if (editorBody) {
                                editorBody.querySelectorAll('input').forEach(input => {
                                    if (input.type === 'checkbox' || input.type === 'radio') {
                                        if (input.checked) {
                                            input.setAttribute('checked', 'checked');
                                        } else {
                                            input.removeAttribute('checked');
                                        }
                                    } else {
                                        input.setAttribute('value', input.value);
                                    }
                                });
                                this.form.answer.value = editorBody.innerHTML;
                            }
                        }
                    }
                }
                // Handle Tabel: serialize tableAnswer ke HTML
                else if (this.questionType === 'table' && this.question.tableData) {
                    const td = this.question.tableData;
                    const col1Label = td.col1 || 'Benar';
                    const col2Label = td.col2 || 'Salah';
                    const colStmtLabel = td.colStatement || 'Pernyataan';
                    let rows = '';
                    this.tableAnswer.forEach((row, idx) => {
                        const radioName = 'answers[' + idx + ']';
                        const stmtContent = (row.statement || '').trim();
                        rows += '<tr>';
                        rows += '<td style="width:50px;min-width:50px;max-width:50px;text-align:center;font-weight:bold;vertical-align:middle;">' + (idx + 1) + '</td>';
                        rows += '<td class="text-justify table-statement-cell" style="text-align:justify !important;text-justify:inter-word;vertical-align:middle;"><div class="statement-scroll-wrap">' + stmtContent + '</div></td>';
                        rows += '<td style="width:90px;min-width:90px;max-width:90px;text-align:center;vertical-align:middle;"><input type="radio" name="' + radioName + '" value="col1"' + (row.selected === 'col1' ? ' checked="checked"' : '') + ' /></td>';
                        rows += '<td style="width:90px;min-width:90px;max-width:90px;text-align:center;vertical-align:middle;"><input type="radio" name="' + radioName + '" value="col2"' + (row.selected === 'col2' ? ' checked="checked"' : '') + ' /></td>';
                        rows += '</tr>';
                    });
                    const thead = '<thead><tr><th style="width:50px;min-width:50px;max-width:50px;text-align:center;">No</th><th style="text-align:center;">' + colStmtLabel + '</th><th style="width:90px;min-width:90px;max-width:90px;text-align:center;">' + col1Label + '</th><th style="width:90px;min-width:90px;max-width:90px;text-align:center;">' + col2Label + '</th></tr></thead>';
                    this.form.answer.value = '<table border="1" class="table table-bordered mb-0" style="width:100%;table-layout:fixed;">' + thead + '<tbody>' + rows + '</tbody></table>';
                }
                // Handle List: serialize listAnswer ke HTML
                else if (this.questionType === 'list' && this.listAnswer.length) {
                    let items = '';
                    this.listAnswer.forEach((item, idx) => {
                        const checkboxName = 'answers[' + idx + ']';
                        const content = (item.content || '').trim();
                        items += '<li style="list-style:none;margin-bottom:10px;text-align:justify !important;display:flex;align-items:flex-start;width:100%;"><input type="checkbox" name="' + checkboxName + '" value="' + idx + '"' + (item.checked ? ' checked="checked"' : '') + ' style="margin-right:10px;margin-top:4px;flex-shrink:0;" /><div class="list-statement-content" style="flex-grow:1;min-width:0;max-width:100%;overflow-x:auto;overflow-y:hidden;text-align:justify !important;text-justify:inter-word;">' + content + '</div></li>';
                    });
                    this.form.answer.value = '<ul class="list-unstyled mb-0" style="list-style:none;padding-left:0;text-align:justify !important;">' + items + '</ul>';
                }

                let addAnswer = !this.question.studentAnswer && this.form.answer.value;
                let updateAnswer = this.question.studentAnswer && this.question.studentAnswer.value !== this.form.answer.value;
                if (addAnswer || updateAnswer) {
                    this.axios.post(process.env.API_URL + '/question/answer', Object.assign({}, this.form.answer, { questionID: this.question.id })).then(response => {
                        if (response.data.status) {
                            let pagination = null;
                            if (!this.tryout.isLocked && this.tryout.tryoutGroups && this.tryout.tryoutGroups.length) {
                                let tryoutSubject = this.paginations.find(tryoutSubject => tryoutSubject.id === this.question.tryoutSubjectID);
                                if (tryoutSubject) {
                                    pagination = tryoutSubject.questions.find(question => question.id === this.question.id);
                                }
                            } else {
                                pagination = this.paginations.find(question => question.id === this.question.id);
                            }
                            if (pagination) {
                                let answer = response.data.data;
                                pagination.studentAnswer = !Array.isArray(answer) ? answer : null;
                                if (nextPage) {
                                    this.paginate(nextPage);
                                }
                            }
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                            this.$router.replace({ name: 'tryout/view', params: { id: this.tryout.id } });
                        }
                    });
                } else if (nextPage) {
                    this.paginate(nextPage);
                }
            },
            async paginate(page) {
                if (!this.tryoutSubject || !this.tryoutSubject.id) return;
                
                this.form.answer.value = "";
                this.tableAnswer = [];
                this.listAnswer = [];
                this.page = page;
                try {
                    const response = await this.axios.get(process.env.API_URL + '/question/selected', { 
                        params: { tryoutSubjectID: this.tryoutSubject.id, order: page } 
                    });
                    if (response.data && response.data.data) {
                        this.question = response.data.data;

                        // Smart parser: deteksi tipe soal dari HTML
                        const answerHTML = this.question.answer || '';
                        const defaultHTML = this.question.defaultAnswer || '';
                        const hasTable = this.question.isEssay && (
                            (answerHTML.includes('<table') && answerHTML.includes('type="radio"')) ||
                            (defaultHTML.includes('<table') && defaultHTML.includes('type="radio"'))
                        );
                        const hasList = this.question.isEssay && (
                            (answerHTML.includes('<ul') && answerHTML.includes('type="checkbox"')) ||
                            (defaultHTML.includes('<ul') && defaultHTML.includes('type="checkbox"'))
                        );

                        if (hasTable) {
                            // Parse tableData dari defaultAnswer HTML (struktur soal)
                            try {
                                const parser = new DOMParser();
                                const docDefault = parser.parseFromString(defaultHTML || answerHTML, 'text/html');
                                const table = docDefault.querySelector('table');
                                if (table) {
                                    let headers = table.querySelectorAll('thead th');
                                    if (!headers || headers.length === 0) {
                                        const firstTr = table.querySelector('tr');
                                        if (firstTr) {
                                            headers = firstTr.querySelectorAll('th, td');
                                        }
                                    }
                                    let colStmtLabel = 'Pernyataan';
                                    let col1Label = 'Benar';
                                    let col2Label = 'Salah';
                                    if (headers.length === 3) {
                                        colStmtLabel = headers[0] ? headers[0].textContent.trim() : 'Pernyataan';
                                        col1Label = headers[1] ? headers[1].textContent.trim() : 'Benar';
                                        col2Label = headers[2] ? headers[2].textContent.trim() : 'Salah';
                                    } else if (headers.length >= 4) {
                                        colStmtLabel = headers[1] ? headers[1].textContent.trim() : 'Pernyataan';
                                        col1Label = headers[2] ? headers[2].textContent.trim() : 'Benar';
                                        col2Label = headers[3] ? headers[3].textContent.trim() : 'Salah';
                                    }
                                    this.question.tableData = {
                                        colStatement: colStmtLabel,
                                        col1: col1Label,
                                        col2: col2Label,
                                        rows: []
                                    };
                                    let trList = table.querySelectorAll('tbody tr');
                                    if (!trList || trList.length === 0) {
                                        trList = table.querySelectorAll('tr');
                                    }
                                    trList.forEach(tr => {
                                        if (!tr.querySelector('input[type="radio"]')) return;
                                        const cells = tr.querySelectorAll('td');
                                        if (cells.length >= 3) {
                                            const stmtCell = (cells.length === 3) ? cells[0] : cells[1];
                                            const stmtClone = stmtCell.cloneNode(true);
                                            stmtClone.querySelectorAll('input').forEach(inp => inp.remove());
                                            const scrollWrap = stmtClone.querySelector('.statement-scroll-wrap');
                                            let cleanContent = scrollWrap ? scrollWrap.innerHTML.trim() : stmtClone.innerHTML.trim();
                                            cleanContent = cleanContent.replace(/(<p>(&nbsp;|\s)*<\/p>|<br\s*\/?>)+$/gi, '').trim();
                                            this.question.tableData.rows.push(cleanContent);
                                        }
                                    });
                                }
                            } catch (e) { /* ignore */ }

                            // Parse jawaban siswa dari studentAnswer
                            const studentAnswerHTML = this.question.studentAnswer ? this.question.studentAnswer.value : '';
                            try {
                                const parser = new DOMParser();
                                const docAnswer = parser.parseFromString(studentAnswerHTML, 'text/html');
                                const tbl = docAnswer.querySelector('table');
                                let rawRows = tbl ? tbl.querySelectorAll('tbody tr') : [];
                                if (!rawRows || rawRows.length === 0) rawRows = tbl ? tbl.querySelectorAll('tr') : [];
                                const rows = Array.from(rawRows).filter(r => r.querySelector('input[type="radio"]'));
                                const statements = this.question.tableData ? this.question.tableData.rows : [];
                                this.tableAnswer = statements.map((stmt, idx) => {
                                    let cleanStmt = typeof stmt === 'string' ? stmt : (stmt.statement || '');
                                    if (cleanStmt.includes('class="statement-scroll-wrap"')) {
                                        const m = cleanStmt.match(/<div class="statement-scroll-wrap">([\s\S]*?)<\/div>/i);
                                        if (m) cleanStmt = m[1];
                                    }
                                    cleanStmt = cleanStmt.replace(/(<p>(&nbsp;|\s)*<\/p>|<br\s*\/?>)+$/gi, '').trim();

                                    let selected = null;
                                    if (rows[idx]) {
                                        const radios = Array.from(rows[idx].querySelectorAll('input[type="radio"]'));
                                        if (radios.length >= 2) {
                                            const r1 = radios[0];
                                            const r2 = radios[1];
                                            const isR1 = r1 && (r1.checked || r1.hasAttribute('checked') || (r1.outerHTML && /checked/i.test(r1.outerHTML)));
                                            const isR2 = r2 && (r2.checked || r2.hasAttribute('checked') || (r2.outerHTML && /checked/i.test(r2.outerHTML)));
                                            if (isR1) selected = 'col1';
                                            else if (isR2) selected = 'col2';
                                        }
                                    }
                                    return { statement: cleanStmt, selected };
                                });
                            } catch (e) { this.tableAnswer = []; }

                            this.form.answer.value = this.question.studentAnswer ? this.question.studentAnswer.value : '';

                        } else if (hasList) {
                            // Parse listData dari defaultAnswer HTML (struktur soal)
                            try {
                                const parser = new DOMParser();
                                const docDefault = parser.parseFromString(defaultHTML || answerHTML, 'text/html');
                                const ul = docDefault.querySelector('ul');
                                if (ul) {
                                    this.question.listData = { items: [] };
                                    ul.querySelectorAll('li').forEach(li => {
                                        const contentDiv = li.querySelector('.list-statement-content');
                                        let content = '';
                                        if (contentDiv) {
                                            content = contentDiv.innerHTML.trim();
                                        } else {
                                            const liClone = li.cloneNode(true);
                                            liClone.querySelectorAll('input').forEach(inp => inp.remove());
                                            const lbl = liClone.querySelector('label');
                                            content = lbl ? lbl.innerHTML.trim() : liClone.innerHTML.trim();
                                        }
                                        this.question.listData.items.push(content);
                                    });
                                }
                            } catch (e) { /* ignore */ }

                            // Parse jawaban siswa dari studentAnswer
                            const studentAnswerHTML = this.question.studentAnswer ? this.question.studentAnswer.value : '';
                            try {
                                const parser = new DOMParser();
                                const docAnswer = parser.parseFromString(studentAnswerHTML, 'text/html');
                                const ul = docAnswer.querySelector('ul');
                                const lis = ul ? ul.querySelectorAll('li') : [];
                                const contents = this.question.listData ? this.question.listData.items : [];
                                this.listAnswer = contents.map((content, idx) => {
                                    let checked = false;
                                    if (lis[idx]) {
                                        const cb = lis[idx].querySelector('input[type="checkbox"]');
                                        checked = cb ? (cb.checked || cb.hasAttribute('checked') || (cb.outerHTML && /checked/i.test(cb.outerHTML))) : false;
                                    }
                                    return { content, checked };
                                });
                            } catch (e) { this.listAnswer = []; }

                            this.form.answer.value = this.question.studentAnswer ? this.question.studentAnswer.value : '';

                        } else {
                            // Essay murni atau Pilihan Ganda
                            let defaultAns = this.question.defaultAnswer || '';
                            if (this.isNumericEssay) {
                                defaultAns = defaultAns
                                    .replace(/<div[^>]*class="essay-numeric-input"[^>]*>/gi, '')
                                    .replace(/<div[^>]*data-numeric="true"[^>]*>/gi, '')
                                    .replace(/<\/div>/gi, '')
                                    .trim();
                            }
                            this.form.answer.value = this.question.studentAnswer 
                                ? this.question.studentAnswer.value 
                                : this.question.isEssay 
                                    ? defaultAns 
                                    : '';
                            this.$nextTick(() => {
                                const editor = window.tinymce.get('text-editor');
                                if (editor) {
                                    editor.setContent(this.form.answer.value || '');
                                    if (this.isNumericEssay) {
                                        this.setupNumericEditor(editor);
                                    }
                                }
                            });
                        }
                    }
                } catch (err) {
                    console.error('[ERROR] paginate failed:', err);
                }
                window.scrollTo(0, 0);
            },
            async fetchPaginations() {
                let params = {};
                let url = '';
                if (this.tryoutGroup && this.tryoutGroup.id && !this.tryout.isLocked) {
                    url = '/question/group-pagination';
                    params = { tryoutGroupID: this.tryoutGroup.id };
                } else if (this.tryoutSubject && this.tryoutSubject.id) {
                    url = '/question/pagination';
                    params = { tryoutSubjectID: this.tryoutSubject.id };
                } else {
                    return;
                }

                try {
                    const response = await this.axios.get(process.env.API_URL + url, { params });
                    if (response.data && response.data.data) {
                        this.paginations = response.data.data;
                    }
                } catch (err) {
                    console.error('[ERROR] fetchPaginations failed:', err);
                }
            },
            isActive(number) {
                let currentOrder = this.question.order;
                if (this.question.packageQuestions && this.question.packageQuestions.length) {
                    currentOrder = this.question.packageQuestions[0].order;
                }
                return currentOrder === number;
            },
            parseDurationToMs(durationVal) {
                if (!durationVal) return 0;
                if (typeof durationVal === 'number') {
                    return durationVal > 1000 ? durationVal : durationVal * 60 * 1000;
                }
                let str = String(durationVal).trim();
                if (/^\d+$/.test(str)) {
                    return parseInt(str, 10) * 60 * 1000;
                }
                if (/^\d{1,2}:\d{2}$/.test(str)) {
                    str = '00:' + str;
                }
                let dur = this.$moment.duration(str);
                return (dur && dur.isValid && dur.isValid()) ? dur.asMilliseconds() : 0;
            },
            initTime() {
                this.isTimerReady = false;
                let timeRemaining = '';
                let isGroupUnlocked = !this.tryout.isLocked && this.tryout.tryoutGroups && this.tryout.tryoutGroups.length;

                // 1. Dapatkan timeRemaining dari sumber yang valid
                if (isGroupUnlocked) {
                    if (this.tryoutGroup && this.tryoutGroup.groupAttempts && this.tryoutGroup.groupAttempts.length) {
                        timeRemaining = this.tryoutGroup.groupAttempts[0].timeRemaining;
                    }
                } else {
                    if (this.tryoutSubject && this.tryoutSubject.subjectAttempts && this.tryoutSubject.subjectAttempts.length) {
                        timeRemaining = this.tryoutSubject.subjectAttempts[0].timeRemaining;
                    }
                }

                // 2. Parse sisa durasi ke milidetik
                let durationMs = this.parseDurationToMs(timeRemaining);

                let hasAttemptAlready = isGroupUnlocked
                    ? (this.tryoutGroup && this.tryoutGroup.groupAttempts && this.tryoutGroup.groupAttempts.length > 0)
                    : (this.tryoutSubject && this.tryoutSubject.subjectAttempts && this.tryoutSubject.subjectAttempts.length > 0);

                // Jika attempt sudah pernah berjalan dan waktu tersisa habis (00:00:00), otomatis submit
                if (hasAttemptAlready && (timeRemaining === '00:00:00' || (timeRemaining && durationMs < 1000))) {
                    console.log('[INIT_TIME] Sisa waktu pengerjaan habis (00:00:00), otomatis submit!');
                    this.time.displayString = '00:00:00';
                    this.submit(true);
                    return;
                }

                // 3. Fallback jika attempt baru pertama kali dibuat dan durasi awal dikalkulasi dari duration soal
                if (durationMs < 1000) {
                    let rawDuration = isGroupUnlocked
                        ? (this.tryoutGroup ? this.tryoutGroup.duration : null)
                        : (this.tryoutSubject ? this.tryoutSubject.duration : null);

                    durationMs = this.parseDurationToMs(rawDuration);
                }

                if (durationMs < 1000) {
                    console.warn('[INIT_TIME] Durasi waktu tidak dapat dikalkulasi atau sudah habis');
                    this.time.displayString = '00:00:00';
                    this.submit(true);
                    return;
                }

                this.time.duration = durationMs;

                this.$nextTick(() => {
                    requestAnimationFrame(activeTime => {
                        this.startTime = activeTime;
                        this.isTimerReady = true;

                        let initialMoment = this.$moment(durationMs).utcOffset(0);
                        this.time.displayString = initialMoment.format('HH:mm:ss');
                        this.$set(this.time, 'remaining', initialMoment);
                        
                        this.cron();
                    });
                });
            },
            async loadQuestionsAndTimer() {
                await this.fetchPaginations();
                await this.paginate(1);
                
                this.isDataLoaded = true;
                
                this.$nextTick(() => {
                    this.initTime();
                });
            },
            async fetchData() {
                this.isDataLoaded = false;
                this.isTimerReady = false;
                this.startTime = 0;
                this.time = {
                    remaining: null,
                    duration: null,
                    displayString: '',
                    remainingString: ''
                };
                this.submitAttemptCount = 0;
                this.inactiveTime = 0;
                this.modal.attempt = false; 
                this.modal.passcode = false;
                this.modal.timeWarning = false;
                this.question = { choices: [] };
                this.paginations = [];
                
                clearInterval(this.intervals.cron);
                clearInterval(this.intervals.confirm);
                this.modal.confirm = false;

                try {
                    const response = await this.axios.get(process.env.API_URL + '/tryout/' + this.$route.params.id, {
                        params: { passcode: localStorage.getItem('passcode') },
                        timeout: 30000
                    });

                    if (!response.data || !response.data.status) {
                        return;
                    }

                    this.tryout = response.data.data;
                    
                    // SINKRONISASI PENGATURAN MANAGEMENT & STATUS SERVER:
                    // Jika dari panel management hasSessionChecking = false, langsung bersihkan localStorage & modal
                    if (!this.isSessionCheckEnabled) {
                        localStorage.removeItem('supervisorLocked');
                        this.modal.attempt = false;
                    } else if (this.tryout.isSupervisorLocked) {
                        // KUNCI PENGAWAS DARI SERVER: Terkunci di perangkat lain/browser lain
                        localStorage.setItem('supervisorLocked', 'true');
                        this.modal.attempt = true;
                    }

                    if (!this.tryout.tryoutOnline || !this.tryout.tryoutOnline.isOpen) {
                        return this.$router.replace({ name: 'error', params: { code: 404, message: 'Tryout not found' } });
                    }

                    let hasAttempt = false;
                    let hasPasscode = false;

                    if (this.tryout.tryoutGroups && this.tryout.tryoutGroups.length) {
                        let groupIDParams = parseInt(this.$route.params.tryoutGroupID);
                        this.tryoutGroup = this.tryout.tryoutGroups.find(
                            g => g.id === groupIDParams
                        ) || this.tryout.tryoutGroups[0] || {};
                        
                        if (!this.tryoutGroup.id) {
                            return this.$router.replace({ name: 'error', params: { code: 404, message: 'Group Subject Not found' } });
                        }

                        if (this.tryout.isLocked) {
                            this.tryoutSubject = this.tryoutGroup.tryoutSubjects.find(
                                s => !s.subjectAttempts.length || !s.subjectAttempts[0].isSubmitted
                            ) || {};
                            if (this.tryoutSubject.id) {
                                hasAttempt = this.tryoutSubject.subjectAttempts.length > 0;
                                hasPasscode = this.tryoutGroup.hasPasscode && this.tryoutGroup.tryoutSubjects.length && !this.tryoutGroup.tryoutSubjects[0].subjectAttempts.length;
                            } else {
                                return this.$router.replace({ name: 'tryout/view', params: { id: this.tryout.id } });
                            }
                        } else {
                            this.tryoutSubject = this.tryoutGroup.tryoutSubjects[0] || {};
                            hasAttempt = this.tryoutGroup.groupAttempts && this.tryoutGroup.groupAttempts.length > 0;
                            hasPasscode = this.tryoutGroup.hasPasscode;
                        }
                    } else {
                        let targetID = parseInt(this.$route.params.tryoutSubjectID);
                        this.tryoutSubject = this.tryout.tryoutSubjects.find(s => s.id === targetID) || this.tryout.tryoutSubjects[0] || {};
                        
                        hasAttempt = this.tryoutSubject.subjectAttempts ? this.tryoutSubject.subjectAttempts.length > 0 : false;
                        hasPasscode = this.tryoutSubject.hasPasscode;
                    }

                    if (!this.tryoutSubject.id) {
                        return this.$router.replace({ name: 'error', params: { code: 404, message: 'Subject Not found' } });
                    } else if (hasAttempt) {
                        let isSubmitted = false;
                        if (!this.tryout.isLocked && this.tryout.tryoutGroups && this.tryout.tryoutGroups.length) {
                            isSubmitted = this.tryoutGroup.groupAttempts && this.tryoutGroup.groupAttempts.length && this.tryoutGroup.groupAttempts[0].isSubmitted;
                        } else if (this.tryoutSubject.subjectAttempts && this.tryoutSubject.subjectAttempts.length) {
                            isSubmitted = this.tryoutSubject.subjectAttempts[0].isSubmitted;
                        }
                        if (isSubmitted) {
                            return this.$router.replace({ name: 'tryout/view', params: { id: this.tryout.id } });
                        }
                    }

                    if (hasAttempt) {
                        await this.loadQuestionsAndTimer();

                        // SINKRONISASI KUNCI PENGAWAS (MULTI-DEVICE, MULTI-BROWSER, REFRESH):
                        if (this.isSessionCheckEnabled && (this.tryout.isSupervisorLocked || localStorage.getItem('supervisorLocked') === 'true')) {
                            this.modal.attempt = true;
                            localStorage.setItem('supervisorLocked', 'true');
                        }
                    } else if (hasPasscode) {
                        this.modal.passcode = true;
                        this.form.attempt.passcode = '';
                    } else {
                        await this.attempt();
                    }

                    document.title = 'Tryout Online ' + this.tryout.name + ' - ' + (this.tryoutSubject.subject ? this.tryoutSubject.subject.name : '') + ' ' + this.tryoutSubject.code + ' - ' + process.env.APP_NAME;

                } catch (error) {
                    console.error('[ERROR] fetchData failed:', error);
                    this.$toastr('error', 'Gagal memuat data, silakan refresh halaman', 'Error');
                }
            },
            cron() {
                clearInterval(this.intervals.cron);
                this.trigger = false;

                let delay = 1000;
                let triggerRemain = (3 * 60 * 1000) + delay; 
                let timeoutInactivity = 5 * 1000;

                this.intervals.cron = setInterval(() => {
                    if (this.time.remaining && this.isTimerReady && this.isDataLoaded) {
                        // Cek apakah waktu sudah habis di level cron (memastikan auto-submit tetap jalan meski popup terkunci atau di latar belakang)
                        if (this.time.remaining.valueOf() <= 1000 || this.time.displayString === '00:00:00') {
                            console.log('[CRON] Waktu pengerjaan resmi habis, otomatis submit!');
                            this.modal.attempt = false;
                            this.modal.timeWarning = false;
                            localStorage.removeItem('supervisorLocked');
                            this.submit(true);
                            return;
                        }

                        let timeRemaining = this.$moment.duration(this.time.remaining.valueOf(), 'ms').humanize();
                        
                        // Batas waktu sisa 3 menit memicu modal konfirmasi
                        if (!this.trigger && this.time.remaining.valueOf() <= triggerRemain) {
                            this.trigger = true;
                            this.time.remainingString = timeRemaining;
                            if (!document.hidden) {
                                this.modal.timeWarning = true;
                            }
                        }

                        // DETEKSI BERPINDAH LAYAR / MULTI-MONITOR / WINDOW SIDE-BY-SIDE / KURSOR KELUAR:
                        // Kursor harus tetap berada di window website ujian ini dan window harus aktif/memiliki fokus
                        let hasFocus = document.hasFocus() || this.isEditorActive();
                        let isAway = document.hidden || !hasFocus || !this.isCursorInside;

                        if (this.isSessionCheckEnabled && isAway && !this.modal.attempt) {
                            this.inactiveTime += delay;
                            if (this.inactiveTime >= timeoutInactivity) {
                                this.inactiveTime = 0;
                                this.modal.attempt = true;
                                localStorage.setItem('supervisorLocked', 'true');
                                this.lockSessionOnServer();
                            }
                        } else if (!isAway) {
                            this.inactiveTime = 0;
                        }
                        document.title = timeRemaining + ' - Tryout Online ' + this.tryout.name + ' - ' + (this.tryoutSubject.subject ? this.tryoutSubject.subject.name : '') + ' ' + this.tryoutSubject.code + ' - ' + process.env.APP_NAME;
                    } else {
                        this.inactiveTime = 0;
                    }
                }, delay);
            },
            initTinyMce(e) {
                if (e) {
                    e.on('contextmenu', (evt) => {
                        evt.preventDefault();
                        return false;
                    });
                    e.on('focus', () => {
                        this.isWindowFocused = true;
                        this.isCursorInside = true;
                    });
                    e.on('mouseenter', () => {
                        this.isCursorInside = true;
                    });
                    e.on('mousemove', () => {
                        this.isCursorInside = true;
                    });
                }
                let val = this.form.answer.value || '';
                if (this.isNumericEssay) {
                    val = val
                        .replace(/<div[^>]*class="essay-numeric-input"[^>]*>/gi, '')
                        .replace(/<div[^>]*data-numeric="true"[^>]*>/gi, '')
                        .replace(/<\/div>/gi, '')
                        .trim();
                    e.setContent(val);
                    this.setupNumericEditor(e);
                } else {
                    e.setContent(val);
                }
            },
            setupNumericEditor(editor) {
                if (!editor) return;

                const body = editor.getBody();
                if (body) {
                    body.setAttribute('inputmode', 'numeric');
                    body.setAttribute('pattern', '[0-9]*');
                }

                if (editor._numericBound) return;
                editor._numericBound = true;

                // Keydown: hanya perbolehkan angka 0-9 dan tombol navigasi / shortcut
                editor.on('keydown', (evt) => {
                    const allowedNavKeys = [
                        'Backspace', 'Delete', 'Tab', 'Escape',
                        'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                        'Home', 'End'
                    ];
                    if (allowedNavKeys.includes(evt.key)) {
                        return;
                    }
                    // Tolak Enter agar jawaban tetap satu baris numerik
                    if (evt.key === 'Enter') {
                        evt.preventDefault();
                        evt.stopPropagation();
                        return false;
                    }
                    // Izinkan shortcut keyboard seperti Ctrl/Cmd + A, C, V, X, Z
                    if ((evt.ctrlKey || evt.metaKey) && ['a', 'c', 'v', 'x', 'z', 'A', 'C', 'V', 'X', 'Z'].includes(evt.key)) {
                        return;
                    }
                    // Jika bukan digit 0-9, tolak input
                    if (!/^[0-9]$/.test(evt.key)) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        return false;
                    }
                });

                // Paste: saring hanya karakter angka yang masuk
                editor.on('paste', (evt) => {
                    evt.preventDefault();
                    const clipboard = (evt.clipboardData || window.clipboardData);
                    let pastedText = clipboard ? clipboard.getData('text') : '';
                    const cleanDigits = (pastedText || '').replace(/[^0-9]/g, '');
                    if (cleanDigits) {
                        editor.insertContent(cleanDigits);
                    }
                });

                // Sanitizer pada input, change, dan keyup
                const sanitizeEditorContent = () => {
                    const text = editor.getContent({ format: 'text' }) || '';
                    const cleanDigits = text.replace(/[^0-9]/g, '');
                    if (text !== cleanDigits) {
                        const html = cleanDigits ? `<p>${cleanDigits}</p>` : '';
                        editor.setContent(html);
                        this.form.answer.value = html;
                    }
                };

                editor.on('input', sanitizeEditorContent);
                editor.on('change', sanitizeEditorContent);
                editor.on('keyup', sanitizeEditorContent);
            },
            // Handler anti-context menu (mouse klik kanan & HP touch-hold)
            handleContextMenu(e) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            },
            // Handler anti-copy & anti-cut
            handleCopy(e) {
                const target = e.target;
                const tag = target && target.tagName ? target.tagName.toLowerCase() : '';
                // Izinkan input biasa (seperti field password pengawas/soal) jika diperlukan
                if (tag === 'input' || tag === 'textarea') {
                    return true;
                }
                e.preventDefault();
                if (e.clipboardData) {
                    e.clipboardData.clearData();
                }
                return false;
            },
            // Handler anti seleksi teks
            handleSelectStart(e) {
                const target = e.target;
                const tag = target && target.tagName ? target.tagName.toLowerCase() : '';
                if (tag === 'input' || tag === 'textarea') {
                    return true;
                }
                e.preventDefault();
                return false;
            },
            // Handler anti drag gambar / teks
            handleDragStart(e) {
                e.preventDefault();
                return false;
            },
            // Handler pencegahan shortcut keyboard copy/cut/print/source/inspect
            handleKeyDown(e) {
                const target = e.target;
                const tag = target && target.tagName ? target.tagName.toLowerCase() : '';
                const isInput = tag === 'input' || tag === 'textarea';

                if (e.ctrlKey || e.metaKey) {
                    const key = (e.key || '').toLowerCase();
                    // Cegah copy (C), cut (X), dan select all (A) jika bukan di dalam kotak input
                    if (!isInput && (key === 'c' || key === 'x' || key === 'a')) {
                        e.preventDefault();
                        return false;
                    }
                    // Cegah View Source (Ctrl+U), Print (Ctrl+P), Save (Ctrl+S)
                    if (key === 'u' || key === 'p' || key === 's') {
                        e.preventDefault();
                        return false;
                    }
                    // Cegah Inspect Element (Ctrl+Shift+I / Cmd+Option+I / Ctrl+Shift+C / Ctrl+Shift+J)
                    if ((e.shiftKey || e.altKey) && (key === 'i' || key === 'c' || key === 'j')) {
                        e.preventDefault();
                        return false;
                    }
                }
                // Cegah F12
                if (e.key === 'F12') {
                    e.preventDefault();
                    return false;
                }
            }
        },
        created() {
            window.addEventListener('popstate', this.handlePopState);
            this.fetchData();
        },
        mounted() {
            window.addEventListener('blur', this.handleWindowBlur);
            window.addEventListener('focus', this.handleWindowFocus);
            document.documentElement.addEventListener('mouseleave', this.handleMouseLeave);
            document.documentElement.addEventListener('mouseenter', this.handleMouseEnter);
            window.addEventListener('mouseout', this.handleWindowMouseOut);
            document.addEventListener('mousemove', this.handleMouseMove);
            document.addEventListener('visibilitychange', this.handleVisibilityChange);

            document.addEventListener('contextmenu', this.handleContextMenu, true);
            document.addEventListener('copy', this.handleCopy, true);
            document.addEventListener('cut', this.handleCopy, true);
            document.addEventListener('selectstart', this.handleSelectStart, true);
            document.addEventListener('dragstart', this.handleDragStart, true);
            document.addEventListener('keydown', this.handleKeyDown, true);
        },
        beforeDestroy() {
            window.removeEventListener('blur', this.handleWindowBlur);
            window.removeEventListener('focus', this.handleWindowFocus);
            document.documentElement.removeEventListener('mouseleave', this.handleMouseLeave);
            document.documentElement.removeEventListener('mouseenter', this.handleMouseEnter);
            window.removeEventListener('mouseout', this.handleWindowMouseOut);
            document.removeEventListener('mousemove', this.handleMouseMove);
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);

            window.removeEventListener('popstate', this.handlePopState);
            for (let index in this.intervals) {
                clearInterval(this.intervals[index]);
            }
            document.removeEventListener('contextmenu', this.handleContextMenu, true);
            document.removeEventListener('copy', this.handleCopy, true);
            document.removeEventListener('cut', this.handleCopy, true);
            document.removeEventListener('selectstart', this.handleSelectStart, true);
            document.removeEventListener('dragstart', this.handleDragStart, true);
            document.removeEventListener('keydown', this.handleKeyDown, true);
        }
    };
</script>

<style scoped>
    .pagination .page-item .page-link{
        min-width: 2rem;
        height: 2rem;
        border-radius: 50% !important;
        line-height: 1.8rem;
        padding: 0.1rem;
    }
    .pagination .page-item.active .page-link{
        background: rgba(218,26,49,.7);
        color: #fff;
    }
    .pagination .page-item.empty:not(.active) .page-link{
        background: #fff;
        color: #DA1A31;
        border: 1.2px solid #DA1A31;
        font-family: 'Ubuntu-Medium';
    }
    /deep/ .table td.text-justify,
    /deep/ .table td.text-justify p,
    /deep/ .table td:nth-child(2),
    /deep/ .table td:nth-child(2) p,
    /deep/ .table-statement-cell,
    /deep/ .table-statement-cell p {
        text-align: justify !important;
        text-justify: inter-word !important;
    }
    /deep/ .list-content-wrap,
    /deep/ .list-content-wrap p,
    /deep/ .list-statement-content,
    /deep/ .list-statement-content p {
        text-align: justify !important;
        text-justify: inter-word !important;
        margin-bottom: 0 !important;
    }
    .list-option-item {
        transition: all 0.15s ease-in-out;
    }

    /* Hover baris tabel berubah warna seperti simulasi Pusmendik */
    /deep/ .table-container-wrap tbody tr,
    /deep/ .table-responsive tbody tr {
        transition: background-color 0.15s ease-in-out;
    }
    /deep/ .table-container-wrap tbody tr:hover td,
    /deep/ .table-responsive tbody tr:hover td {
        background-color: #edf4fc !important;
    }

    /* Hover effect pada list option item */
    .list-option-item:hover {
        background-color: #edf4fc !important;
    }

    /* Tabel soal: fixed layout agar header tidak bergeser dan ukurannya normal, hanya baris data di bawahnya yang bisa digeser jika ada foto panjang */
    /deep/ .table-container-wrap,
    /deep/ .table-responsive {
        overflow-x: visible !important;
        overflow: visible !important;
    }
    /deep/ .table-container-wrap table,
    /deep/ .table-responsive table {
        table-layout: fixed !important;
        width: 100% !important;
        border-collapse: collapse !important;
    }
    /deep/ .table-container-wrap th:nth-child(1),
    /deep/ .table-container-wrap td:nth-child(1),
    /deep/ .table-responsive th:nth-child(1),
    /deep/ .table-responsive td:nth-child(1) {
        width: 50px !important;
        min-width: 50px !important;
        max-width: 50px !important;
        background-color: #ffffff !important;
        text-align: center !important;
        vertical-align: middle !important;
        cursor: default !important;
    }
    /deep/ .table-container-wrap thead th:nth-child(1),
    /deep/ .table-responsive thead th:nth-child(1) {
        background-color: #f8f9fa !important;
        cursor: default !important;
    }

    /* Header Statement di tengah dan tetap di posisinya (tidak ikut geser) */
    /deep/ .table-container-wrap thead th:nth-child(2),
    /deep/ .table-responsive thead th:nth-child(2) {
        text-align: center !important;
        background-color: #f8f9fa !important;
        vertical-align: middle !important;
        width: auto !important;
        cursor: default !important;
    }

    /* Kolom statement baris data di bawah header: vertikal persis di tengah */
    /deep/ .table-container-wrap td.table-statement-cell,
    /deep/ .table-container-wrap td:nth-child(2),
    /deep/ .table-responsive td.table-statement-cell,
    /deep/ .table-responsive td:nth-child(2) {
        width: auto !important;
        vertical-align: middle !important;
        cursor: default !important;
        padding-top: 0.75rem !important;
        padding-bottom: 0.75rem !important;
        overflow: hidden !important;
    }

    /* Wrapper khusus di dalam sel statement agar hanya baris tersebut yang bergeser */
    /deep/ .statement-scroll-wrap {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch;
        margin: 0 !important;
        padding: 0 !important;
    }

    /deep/ .statement-scroll-wrap p,
    /deep/ .table-statement-cell p {
        margin: 0 !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding: 0 !important;
        line-height: 1.5 !important;
    }
    /deep/ .statement-scroll-wrap p:not(:last-child),
    /deep/ .table-statement-cell p:not(:last-child) {
        margin-bottom: 0.35rem !important;
    }
    /deep/ .statement-scroll-wrap p:empty,
    /deep/ .table-statement-cell p:empty {
        display: none !important;
    }

    /deep/ .table-container-wrap th:nth-child(3),
    /deep/ .table-container-wrap td:nth-child(3),
    /deep/ .table-responsive th:nth-child(3),
    /deep/ .table-responsive td:nth-child(3) {
        width: 90px !important;
        min-width: 90px !important;
        max-width: 90px !important;
        background-color: #ffffff !important;
        text-align: center !important;
        vertical-align: middle !important;
        cursor: pointer !important;
    }
    /deep/ .table-container-wrap thead th:nth-child(3),
    /deep/ .table-responsive thead th:nth-child(3) {
        background-color: #f8f9fa !important;
        cursor: default !important;
    }
    /deep/ .table-container-wrap th:nth-child(4),
    /deep/ .table-container-wrap td:nth-child(4),
    /deep/ .table-responsive th:nth-child(4),
    /deep/ .table-responsive td:nth-child(4) {
        width: 90px !important;
        min-width: 90px !important;
        max-width: 90px !important;
        background-color: #ffffff !important;
        text-align: center !important;
        vertical-align: middle !important;
        cursor: pointer !important;
    }
    /deep/ .table-container-wrap thead th:nth-child(4),
    /deep/ .table-responsive thead th:nth-child(4) {
        background-color: #f8f9fa !important;
        cursor: default !important;
    }

    /* Posisi radio button Yes / No di kolom tabel agar tepat di tengah (vertically & horizontally centered) */
    /deep/ .table-container-wrap td .custom-control.custom-radio,
    /deep/ .table-responsive td .custom-control.custom-radio {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        vertical-align: middle !important;
        margin: 0 auto !important;
        padding: 0 !important;
        min-height: 20px !important;
        width: 20px !important;
        height: 20px !important;
        position: relative !important;
    }
    /deep/ .table-container-wrap td .custom-control-label,
    /deep/ .table-responsive td .custom-control-label {
        margin: 0 !important;
        width: 20px !important;
        height: 20px !important;
        display: block !important;
        position: relative !important;
    }
    /deep/ .table-container-wrap td .custom-control-label::before,
    /deep/ .table-container-wrap td .custom-control-label::after,
    /deep/ .table-responsive td .custom-control-label::before,
    /deep/ .table-responsive td .custom-control-label::after {
        top: 0 !important;
        bottom: 0 !important;
        left: 0 !important;
        right: 0 !important;
        margin: auto !important;
        width: 18px !important;
        height: 18px !important;
    }

    /* Gambar di dalam tabel & list mempertahankan ukuran aslinya dan menyatu dengan background */
    /* mix-blend-mode: multiply menyatukan background putih gambar dengan warna biru muda baris saat dihover */
    /deep/ .table-container-wrap table img,
    /deep/ .table-container-wrap td img,
    /deep/ .table-responsive table img,
    /deep/ .table-responsive td img,
    /deep/ .table-statement-cell img,
    /deep/ .statement-scroll-wrap img,
    /deep/ .list-content-wrap img,
    /deep/ .list-statement-content img {
        max-width: none !important;
        height: auto !important;
        display: inline-block !important;
        mix-blend-mode: multiply !important;
        background-color: transparent !important;
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        -webkit-user-drag: none !important;
        -khtml-user-drag: none !important;
        -moz-user-drag: none !important;
        -o-user-drag: none !important;
        user-drag: none !important;
        user-select: none !important;
        -webkit-user-select: none !important;
        cursor: default !important;
        pointer-events: auto !important;
    }

    /deep/ .table-container-wrap table td.table-statement-cell,
    /deep/ .table-responsive table td.table-statement-cell {
        cursor: default !important;
        -webkit-touch-callout: none !important;
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
    }

    /* List item bisa di-scroll jika foto sangat panjang */
    /deep/ .list-content-wrap {
        overflow-x: auto !important;
        overflow-y: hidden !important;
        -webkit-overflow-scrolling: touch;
        min-width: 0 !important;
        max-width: 100% !important;
    }

    /* Kursor tangan hanya pada area tombol jawaban (radio & checkbox) */
    .custom-control,
    .custom-control-label,
    .custom-control-input,
    .list-option-item,
    .list-option-item input[type="checkbox"] {
        cursor: pointer !important;
    }

    /* Scrollbar horizontal rapi untuk baris statement dan list: track transparan agar tidak muncul kotak/garis */
    /deep/ .statement-scroll-wrap::-webkit-scrollbar,
    /deep/ .list-content-wrap::-webkit-scrollbar {
        height: 6px;
    }
    /deep/ .statement-scroll-wrap::-webkit-scrollbar-track,
    /deep/ .list-content-wrap::-webkit-scrollbar-track {
        background: transparent !important;
    }
    /deep/ .statement-scroll-wrap::-webkit-scrollbar-thumb,
    /deep/ .list-content-wrap::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }
    /deep/ .statement-scroll-wrap::-webkit-scrollbar-thumb:hover,
    /deep/ .list-content-wrap::-webkit-scrollbar-thumb:hover {
        background: #888;
    }

    /* Deskripsi Soal: jika gambar sangat panjang, pertahankan ukuran aslinya & bisa digeser */
    /deep/ .question-content-wrap {
        overflow-x: auto !important;
        overflow-y: hidden !important;
        -webkit-overflow-scrolling: touch;
        max-width: 100% !important;
    }

    /deep/ .question-content-wrap img {
        max-width: none !important;
        height: auto !important;
        display: inline-block !important;
    }

    /* Scrollbar horizontal rapi untuk Deskripsi Soal: track transparan */
    /deep/ .question-content-wrap::-webkit-scrollbar {
        height: 6px;
    }
    /deep/ .question-content-wrap::-webkit-scrollbar-track {
        background: transparent !important;
    }
    /deep/ .question-content-wrap::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }
    /deep/ .question-content-wrap::-webkit-scrollbar-thumb:hover {
        background: #888;
    }

    /* Anti-Copy, Anti-Context Menu & Anti-Long Press untuk Halaman Ujian Siswa */
    .student-exam-mode,
    .student-exam-mode * {
        -webkit-touch-callout: none !important; /* Nonaktifkan popup callout/menu di iOS Safari */
        -webkit-user-select: none !important;   /* Safari & Chrome Mobile */
        -khtml-user-select: none !important;
        -moz-user-select: none !important;       /* Firefox */
        -ms-user-select: none !important;        /* Edge / IE */
        user-select: none !important;            /* Modern browsers */
    }

    /* Izinkan input dan textarea agar anak tetap bisa mengetik (seperti input password ujian/pengawas) */
    .student-exam-mode input[type="text"],
    .student-exam-mode input[type="password"],
    .student-exam-mode textarea {
        -webkit-user-select: text !important;
        user-select: text !important;
    }

    /* Pastikan tombol dan opsi jawaban (radio button, checkbox, navigasi soal) tetap berfungsi dan nyaman diklik */
    .student-exam-mode .custom-control,
    .student-exam-mode .custom-control-label,
    .student-exam-mode .custom-control-input,
    .student-exam-mode .list-option-item,
    .student-exam-mode .list-option-item input,
    .student-exam-mode button,
    .student-exam-mode .btn,
    .student-exam-mode .page-link,
    .student-exam-mode a {
        pointer-events: auto !important;
        cursor: pointer !important;
        -webkit-touch-callout: none !important;
        -webkit-user-select: none !important;
        user-select: none !important;
    }

    /* Nonaktifkan drag pada gambar di seluruh soal */
    .student-exam-mode img {
        -webkit-user-drag: none !important;
        -khtml-user-drag: none !important;
        -moz-user-drag: none !important;
        -o-user-drag: none !important;
        user-drag: none !important;
        pointer-events: auto !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/tryout/question/View.vue